import { render } from "./Player.vue?vue&type=template&id=c0bbef80"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2796879663/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__